export default {
    name: 'Errors',
    data() {
        return {
            errors: [], //code, mes
        }
    },
    methods: {
        reset() {
            this.errors = [];
        },
        parse(errorsAr, mes = 'Ошибка: ') {
            for(let key in errorsAr)
                this.errors.push({code: parseInt(key), mes: errorsAr[key]});
            let messages = [];
            this.errors.forEach(m => {
                messages.push(m.mes);
            });
            window.toast.error(mes + messages.join(', ') + '.');
        },
        parseObj(errorsObj, mes = 'Ошибка: ') {
            for(let key in errorsObj)
                this.errors.push({code: parseInt(key), mes: errorsObj[key]});
            let messages = [];
            this.errors.forEach(m => {
                messages.push(m.mes);
            });
            window.toast.error(mes + messages.join(', ') + '.');
        },
        getMes(code) {
            let key = this.errors.findIndex(er => {
                return er.code === code
            });
            return this.errors[key].mes ?? '';
        }
    }
}